module.exports = __webpack_public_path__ + "img/backHome_01.09c20f79.png";